import { StudyConfig } from '@csp/csp-common-config';
import { Maybe, StudyPatientAllowedUsernameEmailDomains, StudyPatientStatusMappings } from '@csp/csp-common-model';
import { RootState } from '../../../state/store';
import { StudyConfigState } from '../model/StudyConfigState';

const getStudyConfigSelector = (state: RootState): Maybe<StudyConfig> => state.studyConfig.config;

export const getStudyConfigStateSelector = (state: RootState): StudyConfigState => state.studyConfig;

export const getStudyConfigErrorSelector = (state: RootState): Maybe<Error> => getStudyConfigStateSelector(state).error;

export const getPatientStatusMappings = (state: RootState): Maybe<StudyPatientStatusMappings> =>
  getStudyConfigSelector(state)?.patientStatusMappings;

export const getPatientAllowedUsernameEmailDomains = (
  state: RootState,
): Maybe<StudyPatientAllowedUsernameEmailDomains> =>
  getStudyConfigSelector(state)?.patientValidation.usernameEmailDomains;
